import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  imports: [MatDialogModule, TranslocoPipe, MatButtonModule],
})
export class LogoutComponent {
}
